module.exports = __webpack_public_path__ + "media/images/lb/192-df2e5044430f0ca4ad2c0a2757cf053b.svg";